import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';
import { useTranslation } from 'react-i18next';

import { formatDate } from '@src/shared/lib';
import { IconButton } from '@src/shared/ui/Button';
import { Box } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';

export default function CalendarHeader(props: PickersCalendarHeaderProps) {
  const { currentMonth, onMonthChange } = props;
  const { t } = useTranslation();

  const prevMonth = new Date(currentMonth);
  prevMonth.setMonth(prevMonth.getMonth() - 1);

  const nextMonth = new Date(currentMonth);
  nextMonth.setMonth(nextMonth.getMonth() + 1);

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <IconButton
        size="small"
        onClick={() => onMonthChange(prevMonth)}
        tooltipTitle={t('common.previous', 'Previous')}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="h4">
        {formatDate(currentMonth, { month: 'long', year: 'numeric' })}
      </Typography>
      <IconButton
        size="small"
        onClick={() => onMonthChange(nextMonth)}
        tooltipTitle={t('common.next', 'Next')}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
}
